module.exports = __webpack_public_path__ + "img/11_of_Diamonds.svg.d4e94a10.png";